import React, { useState, useEffect, memo } from 'react'
import { TransferList } from 'src/components/uiElements/fields/TransferList'
import { Skeleton, Grid } from '@mui/material'
import { useNotify } from 'react-admin'
import { permissionServices } from 'src/services/auth/permission/permission.service'
import { useLoadingPermision } from 'src/components/pages/authentication/user/context/LoadingPermissionContext'

export const WrapperToPermission = memo(({ setList, item, id }) => {
  const notify = useNotify()
  const { loading, startLoading, stopLoading } = useLoadingPermision()
  const [leftData, setLeftData] = useState(item.permissions?.left)
  const [rightData, setRightData] = useState(item.permissions?.right)

  useEffect(() => {
    if (item.applications.checkedApplication && item.clients.checkedClient) {
      ;(async () => {
        startLoading()
        try {
          let allPermissionByApplication = await permissionServices.getPermissionsByApplications(
            item.applications.checkedApplication
          )
          if (allPermissionByApplication) {
            const setValue = () => {
              return {
                left: allPermissionByApplication,
                right: [],
              }
            }
            setLeftData(allPermissionByApplication)
            setRightData([])
            setList((prev) =>
              prev.map((item) => (item.id === id ? { ...item, permissions: setValue() } : item))
            )
            return
          } else {
            notify('ra.notification.noPermissionApplication', { type: 'error' })
          }
        } catch (error) {
          notify('ra.notification.noPermissionApplication', { type: 'error' })
        } finally {
          stopLoading()
        }
      })()
    }

    setList((prev) =>
      prev.map((item) => (item.id === id ? { ...item, permissions: { left: [], right: [] } } : item))
    )
    setLeftData([])
    setRightData([])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item.applications.checkedApplication])

  const handleChangePermissions = (left, right) => {
    setLeftData(left)
    setRightData(right)
    setList((prev) => prev.map((item) => (item.id === id ? {
      ...item,
      permissions: {
        left: left,
        right: right,
      }
    } : item)))
  }

  return (
    <>
      {loading ? (
        <Grid
          container
          spacing={2}
          justifyContent='center'
          alignItems='center'
          className='transferListComponent'
        >
          <Grid item xs={5}>
            <Skeleton variant='rectangular' width={'100%'} height={500} />
          </Grid>
          <Grid item xs={2}>
            <Grid container direction='column' alignItems='center'>
              <Skeleton variant='rectangular' width={'100%'} height={40} />
            </Grid>
          </Grid>
          <Grid item xs={5}>
            <Skeleton variant='rectangular' width={'100%'} height={500} />
          </Grid>
        </Grid>
      ) : (
        <TransferList
          leftData={leftData}
          rightData={rightData}
          setter={handleChangePermissions}
        />
      )}
    </>
  )
})
